<template>
  <div class="layer-popup__container">
    <!-- Title -->
    <div class="title-text">{{ title }}</div>

    <!-- Table -->
    <table v-if="table" style="width: 100%; overflow-x: auto">
      <tr v-for="(value, key) of table" :key="key">
        <td
          style="
            font-weight: bold;
            padding-right: 1em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 120px;
          "
          :title="key"
        >
          {{ key }}
        </td>
        <td v-html="value"></td>
      </tr>
    </table>

    <!-- Images -->
    <div v-if="images" style="display: flex; overflow-x: auto; height: 120px">
      <img
        v-for="(link, index) of images"
        :key="`image-${index}`"
        class="popup__image"
        :src="link"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      /**
       * @type {string}
       */
      title: "",
      /**
       * E.g. { 'prop': 'value' }
       *
       * @type {object}
       */
      table: undefined,
      /**
       * E.g. ['https://abc.com/image-1.png']
       *
       * @type {string[]}
       */
      images: undefined
    };
  }
};
</script>

<style scoped>
.title-text {
  font-weight: 600;
  font-size: 14px;
}

.popup__image {
  width: auto;
  height: 100%;
  margin: 0 5px;
  object-fit: contain;
}

table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 7px;
}

.layer-popup__container {
  padding: 10px 15px;
}
</style>
